import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { CampaignEstimate, CampaignEstimateParams } from "../../marketing.types";
import { requestGetCampaignEstimate } from "./getCampaignEstimate.request";

const useCampaignEstimate = (
  params: CampaignEstimateParams,
  options?: QueryOptions<CampaignEstimate, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["marketing", "campaigns", "estimate", params],
    queryFn: async () => await requestGetCampaignEstimate(params),
    onError: toastServerError,
    keepPreviousData: true,
    ...options
  });

  return { estimate: data, ...rest };
};

export default useCampaignEstimate;
